// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1ubl{width:var(--link-picker-width)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/ui/main.compiled.css"],"names":[],"mappings":"AAAA,WAAW,8BAA8B","sourcesContent":["._1bsb1ubl{width:var(--link-picker-width)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
